import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const ChevronRight = createSvgIcon(React.createElement("polygon", { points: "7,18.8 8.5,20.2 17,11.7 8.5,3.3 7,4.7 14.1,11.7 " }), 'ChevronRight');
export default ChevronRight;
